import * as config from "config";

function nilLog(message?: any, ...optionalParams: any[]) {
    // pass
}

export const log = config.DEBUG ? console.log.bind(console) : nilLog;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/util/debug.ts